<luigi-container
  #luigiContainer
  class="m-auto"
  [viewurl]="url()"
  [id]="generateLuigiHtmlId()"
  webcomponent='{ "selfRegistered": true, "tagName": "dcp-webcomponents-cta-button-root" }'
  [context]="getCtaWebcomponentContext()"
></luigi-container>

@if (showFallback()) {
  <udex-button
    size="Medium"
    design="Primary"
    (click)="openSupportFormFallback()"
    [attr.accessible-name]="'productDetails.contactSupport' | cxTranslate"
    data-cy="cta-fallback-contact-support">
    {{ 'productDetails.contactSupport' | cxTranslate }}
  </udex-button>
}
